import React, { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import CtaBand from '@/components/CtaBand';
import { api, fileUrl } from '@/lib/api';

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState('All');
  useEffect(() => { api.get('/gallery', { params: { limit: 96 } }).then(r => setItems(r.data.items || [])); }, []);
  const cats = ['All', ...Array.from(new Set(items.map(i => i.category)))];
  const list = active === 'All' ? items : items.filter(i => i.category === active);
  return (
    <Layout>
      <PageHeader eyebrow="Project Gallery" title="Real homes. Real businesses. Real craft." subtitle="Recent before-and-afters from across Palm Beach, Broward, and Miami-Dade." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-wrap gap-2 mb-6">
          {cats.map((c) => (
            <button key={c} onClick={() => setActive(c)} data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, '-')}`}
              className={`rounded-full border px-4 py-1.5 text-sm transition-colors-only ${active === c ? 'border-[#17352D] bg-[#17352D] text-white' : 'border-[#E6E9EE] text-slate-700 hover:bg-[#F2F7F5]'}`}>{c}</button>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {list.map((g) => (
            <div key={g.id} className="group relative rounded-2xl overflow-hidden border border-[#E6E9EE] aspect-square bg-[#F2F7F5]">
              <img src={fileUrl(g.image)} alt={g.title} loading="lazy" className="h-full w-full object-cover transition-transform-only group-hover:scale-[1.04]" />
              <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/70 to-transparent text-white">
                <div className="text-[10px] uppercase tracking-[0.16em] opacity-80">{g.category} • {g.city}</div>
                <div className="text-sm font-semibold">{g.title}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <CtaBand />
    </Layout>
  );
}
